export default [
  {
    path: "/report/summary",
    name: "reportSummary",
    component: () => import(
      /*webpackChunkName:'Summary'*/
      "@/views/report/Summary.vue"),
    meta: {},
  },
  {
    path: "/search/host",
    name: "searchHost",
    component: () => import(
      /*webpackChunkName:'SearchHost'*/
      "@/views/search/SearchHost.vue"),
    meta: {},
  },
  {
    path: "/search/query",
    name: "SearchQuery",
    component: () => import(
      /*webpackChunkName:'SearchQuery'*/
      "@/views/search/SearchQuery.vue"),
    meta: {},
  },
  {
    path: "/search/cve",
    name: "searchCve",
    component: () => import(
      /*webpackChunkName:'SearchCve'*/
      "@/views/search/SearchCve.vue"),
    meta: {},
  },
  {
    path: "/search/domain",
    name: "searchDomain",
    component: () => import(
      /*webpackChunkName:'SearchDomain'*/
      "@/views/search/SearchDomain.vue"),
    meta: {},
  },
  {
    path: "/search/advance",
    name: "searchAdvance",
    component: () => import(
      /*webpackChunkName:'SearchAdvance'*/
      "@/views/search/SearchAdvance.vue"),
    meta: {},
  },
  {
    path: "/report/device",
    name: "DeviceReport",
    component: () => import(
      /*webpackChunkName:'DeviceReport'*/
      "@/views/report/DeviceReport.vue"),
    meta: {},
  },
  {
    path: "/schedule/job",
    name: "ScheduleJobList",
    component: () => import(
      /*webpackChunkName:'ScheduleJobList'*/
      "@/views/schedulejob/ScheduleJobList.vue"),
    meta: {},
  },
  {
    path: "/schedule/log",
    name: "ScheduleLogList",
    component: () => import(
      /*webpackChunkName:'ScheduleLogList'*/
      "@/views/schedulejob/ScheduleLogList.vue"),
    meta: {},
  },
]